import TableNumber from "./TableNumber";

export default TableNumber;
